import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#E8E6E0] py-12 mt-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Leaf decoration */}
        <div className="flex justify-center mb-6">
          <svg
            width="100"
            height="60"
            viewBox="0 0 100 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 30C25 25 20 20 20 15C20 10 25 5 30 10C35 15 40 20 45 25"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M50 25C55 20 60 15 65 10C70 5 75 10 75 15C75 20 70 25 65 30"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M45 25C45 30 47 35 50 40C53 35 55 30 55 25"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>
        </div>

        {/* Title */}
        <h3
          className="text-3xl font-light text-center mb-2 tracking-wider text-[#4A4A4A]"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          VALERIE BASTET
        </h3>
        <p
          className="text-center text-sm text-[#7A7A7A] mb-8 tracking-wide"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          Wife, Mother, Sister, Grandmother
        </p>

        {/* Navigation */}
        <div className="flex justify-center space-x-8 mb-8">
          <Link
            to="/"
            className="text-sm tracking-widest uppercase text-[#7A7A7A] hover:text-[#8B7355] transition-colors duration-300"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            HOME
          </Link>
          <Link
            to="/about"
            className="text-sm tracking-widest uppercase text-[#7A7A7A] hover:text-[#8B7355] transition-colors duration-300"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            ABOUT
          </Link>
          <Link
            to="/gallery"
            className="text-sm tracking-widest uppercase text-[#7A7A7A] hover:text-[#8B7355] transition-colors duration-300"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            GALLERY
          </Link>
        </div>

        {/* Copyright */}
        <p
          className="text-center text-xs text-[#9A9A9A] tracking-wide"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          © 2022 Website. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;